<script lang="ts">
  import type { PitchyFishGameStore } from './PitchyFishGameStore';

  export let store: PitchyFishGameStore;
</script>

<div class="request-container">
  <div id="mic-request-title" class="mx-auto mb-8 text-4xl">Enable Microphone</div>

  <p class="text-white text-2xl">Pitchy fish needs access to your microphone to hear you sing.</p>

  <button
    class="text-2xl"
    id="mic-request-button"
    on:click={() => {
      store.microphonePermissionStatus = 'userRequested';
      store.startGame();
    }}>Allow Mic Access</button
  >
</div>

<style lang="postcss">
  .request-container {
    position: relative;
    margin: auto;
    top: 10%;
    height: 80%;
    width: 80%;
    text-align: center;
    z-index: 40;
  }

  #mic-request-title {
    font-family: 'Luckiest Guy', Impact, 'Arial Narrow Bold', sans-serif;
    color: #ffc400;
    text-shadow: 4px 4px 10px black;
  }

  #mic-request-button {
    font-family: 'Luckiest Guy', Impact, 'Arial Narrow Bold', sans-serif;
    padding: 0;
    text-align: center;
    /** padding-top seems to adjust for false vertical centering of this font. */
    padding-top: 5%;
    padding-bottom: 5%;
    position: absolute;
    left: 10%;
    top: 45%;
    width: 80%;
    border-radius: 8%;
    color: black;
    background: linear-gradient(coral, rgb(217, 255, 0));
  }
</style>
